<template lang="pug">
  .cart(v-if="cart")
    .cart__border.cart__border--top
    .cart__border.cart__border--right
    .cart__border.cart__border--bottom
    .cart__border.cart__border--left
    .cart__corner.cart__corner--tl
    .cart__corner.cart__corner--tr
    .cart__corner.cart__corner--bl
    .cart__corner.cart__corner--br
    .cart__decor-top
    .cart__decor-bottom
    .cart__title(v-if="h1") {{h1}}
    .cart__menu
      .cart__menu-list
        router-link.cart__menu-list-item.cart__menu-list-item--disabled(:to="item.link", v-if="cart.menu", v-for="item, index in cart.menu", :key="index", :data-cart-step-num="index + 1")
          .cart__menu-list-item-number
            .cart__menu-list-item-number-text {{item.number}}
          .cart__menu-list-item-title {{item.title}}
    .cart__items
      .cart__item(data-cart-step="vash-zakaz", data-cart-step-num="1")
        .cart__item-content
          YourOrder(v-if="yourOrder", :data="yourOrder")
      .cart__item(data-cart-step="adres-dostavki", data-cart-step-num="2")
        .cart__item-content
          DeliveryAddress(v-if="deliveryAddress", :data="deliveryAddress")
      .cart__item(data-cart-step="oplata", data-cart-step-num="3")
        .cart__item-content
          Payment(v-if="payment", :data="payment")
      .cart__item(data-cart-step="podtverzhdenie", data-cart-step-num="4")
        .cart__item-content
          Verification(v-if="verification", :data="verification")
      .cart__item(data-cart-step="vypolnenie", data-cart-step-num="5")
        .cart__item-content
          Implementation(v-if="implementation", :data="implementation")
    .cart__preloader
      .cart__border.cart__border--right
      .cart__preloader-img
        .cart__preloader-img-color-wr
          .cart__preloader-img-color
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/cart/cart.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import {CartHelpersVue} from '@/mixins/CartHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import YourOrder from '@/components/yourOrder/YourOrder.vue';
import DeliveryAddress from '@/components/deliveryAddress/DeliveryAddress.vue';
import Payment from '@/components/payment/Payment.vue';
import Verification from '@/components/verification/Verification.vue';
import Implementation from '@/components/implementation/Implementation.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Cart',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue],

  data() {
    return {
      cart: null,
      content: {},
      ps: null,
      firstReq: true,
      yourOrder: null,
      deliveryAddress: null,
      payment: null,
      verification: null,
      implementation: null,
      maxStep: 0,
    }
  },

  components: {
    SvgIcon,
    YourOrder,
    DeliveryAddress,
    Payment,
    Verification,
    Implementation
    //Events
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadCartPage', params => {
      this.request(params.url, params);
    });

    EventBus.$on('resetFirstReq', params => {
      this.firstReq = true;
    });
  },

  methods: {
    request(url, params) {
      let cartRoute = '';
      let step = params.params.step || 'vash-zakaz';

      if(params.params.step === 'vash-zakaz') {
        cartRoute = 'getYourOrder';
      }
      else if(params.params.step === 'adres-dostavki') {
        cartRoute = 'getDeliveryAddress';
      }
      else if(params.params.step === 'oplata') {
        cartRoute = 'getPayment';
      }
      else if(params.params.step === 'podtverzhdenie') {
        cartRoute = 'getVerification';
      }
      else if(params.params.step === 'vypolnenie') {
        cartRoute = 'getImplementation';
      }
      else {
        cartRoute = 'getYourOrder';
      }

      if(this.firstReq) {
        this.req('CartPage:getCartPage', {url: '/korzina'}, res => {
          this.firstReq = false;

          if(this.checkProperty(res.content)) {
            if(res.content.disabledBasket) {
              window.location.href = '/';
            } else {
              this.cart = res.content;
            }
          }

          this.localReq(cartRoute, step, url);
        }, 'cart');
      }
      else {
        this.localReq(cartRoute, step, url);
      }

    },

    localReq(cartRoute, step, url) {
      this.preloader('show');
      this.clearOldData();
      this.req(`CartPage:${cartRoute}`, {url}, res => {
        if(cartRoute === 'getYourOrder' && this.checkProperty(res.step)) {
          this.yourOrder = res;
        }
        else if(cartRoute === 'getDeliveryAddress' && this.checkProperty(res.step)) {
          this.deliveryAddress = res;
        }
        else if(cartRoute === 'getPayment' && this.checkProperty(res.step)) {
          this.payment = res;
        }
        else if(cartRoute === 'getVerification' && this.checkProperty(res.step)) {
          this.verification = res;
        }
        else if(cartRoute === 'getImplementation' && this.checkProperty(res.step)) {
          this.implementation = res;
        }

        this.$nextTick(() => {
          this.getMiniCart(this.getCartId());
          this.setActiveBlock(step);
          this.initScroll(cartRoute);
          this.preloader('hide');
        });
      }, '', 'localPageRequest');
    },

    clearOldData() {
      this.yourOrder = null;
      this.deliveryAddress = null;
      this.payment = null;
      this.verification = null;
      this.implementation = null;
    },

    setActiveBlock(step) {
      let num = $(`[data-cart-step="${step}"]`).data('cart-step-num');
      let productsToCart = $('.cart-widget__count-num').text();

      if(productsToCart == 0) {
        num = 1;
        this.maxStep = 1;
        this.cartStep('/korzina/vash-zakaz');
      }

      if(this.maxStep < num) {
        this.maxStep = num;
      }

      $('.cart__item--active').removeClass('cart__item--active').removeClass('cart__item--anima');
      $(`.cart__item[data-cart-step="${step}"]`).addClass('cart__item--active');
      setTimeout(() => {
        $(`[data-cart-step="${step}"]`).addClass('cart__item--anima');
      }, 100);

      $('.cart__menu-list-item--active').removeClass('cart__menu-list-item--active');
      $(`.cart__menu-list-item[data-cart-step-num="${num}"]`).addClass('cart__menu-list-item--active').removeClass('cart__menu-list-item--disabled');

      $('.cart__menu-list-item').each((i, el) => {
        if($(el).data('cart-step-num') > this.maxStep) {
          $(el).addClass('cart__menu-list-item--disabled');
        } else {
          $(el).removeClass('cart__menu-list-item--disabled');
        }
      });

      if(step == 'vypolnenie') {
        $('.cart__menu-list-item').not('.cart__menu-list-item--active').addClass('cart__menu-list-item--disabled');
      }
    },

    initScroll(cartRoute) {
      let el;

      if(cartRoute === 'getVerification' && $(window).width() >= 1260) {
        el = $('.verification__left-list')[0];
      } else {
        el = $('.cart__item--active').find('.cart__item-content')[0]
      }

      if(this.ps === null) {
        this.ps = new PerfectScrollbar(el, {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.destroy();
        this.ps = null;
        this.ps = new PerfectScrollbar(el, {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
        el.scrollTop = 0;
      }
    },

    preloader(action) {
      let $preloader = $('.cart__preloader');

      if(action === 'show') {
        $preloader.removeClass('cart__preloader--hide').addClass('cart__preloader--animation');
      }

      if(action === 'hide') {
        $preloader.addClass('cart__preloader--hide');

        setTimeout(() => {
          $preloader.removeClass('cart__preloader--animation');
        }, 500);
      }
    },
  }
}
</script>
